import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import {NotesService} from '../../../services/notes.service';
import {PredefinedNoteDataModel} from '../../../models/notes/predefined-note-data.model';
import {PredefinedNoteSetDataModel} from '../../../models/notes/predefined-note-set-data.model';
import {MessagingService} from '../../../services/messaging.service';
import {OrderChangeModel} from '../../../models/ui/OrderChangeModel';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {ConfirmComponent} from '../../../dialog/confirm-dialog/confirm.component';
import {DialogService} from '../../../services/dialog.service';

@Component({
  selector: 'app-tdo-macro-notes',
  templateUrl: './tdo-macro-notes.component.html',
  styleUrls: ['./tdo-macro-notes.component.scss']
})
export class TdoMacroNotesComponent implements OnInit, AfterViewInit {
  @ViewChild('textarea') textArea: ElementRef;
  @ViewChild('titleInput') titleInput: ElementRef;

  selectedPredefinedNote: PredefinedNoteDataModel;
  dataNoteSet: PredefinedNoteSetDataModel;
  editableNote: PredefinedNoteDataModel;
  isLoading = true;

  constructor(private notesService: NotesService,
              private messagingService: MessagingService,
              private dialogService: DialogService,
              private dialogRef: MatDialogRef<TdoMacroNotesComponent>,
              private dialog: MatDialog) { }

  ngOnInit(): void {
    this.notesService.getNoteBoilerplateSet().subscribe((notes) => {
      this.dataNoteSet = notes;
      if (this.dataNoteSet.dataPredefinedNotes.length > 0) {
        this.selectedPredefinedNote = this.dataNoteSet.dataPredefinedNotes[0];
      }
      this.isLoading = false;
    });
  }

  ngAfterViewInit() {
    const tmp = setInterval(() => {
      if (this.textArea) {
        clearInterval(tmp);
        this.textArea.nativeElement.focus();
      }
    }, 200);
  }

  sectionDrop(event: CdkDragDrop<PredefinedNoteSetDataModel>) {
    moveItemInArray(this.dataNoteSet.dataPredefinedNotes, event.previousIndex, event.currentIndex );
    const model = new OrderChangeModel();
    model.id = this.selectedPredefinedNote.PredefinedNoteId;
    model.newOrder = event.currentIndex;
    model.oldOrder = event.previousIndex;
    model.parentId = this.dataNoteSet.NoteSetId;
    this.notesService.changePredefinedNoteOrder(model).subscribe(() => {
      //
    });
  }

  onPredefinedNoteClick(note: PredefinedNoteDataModel) {
    this.selectedPredefinedNote = note;
    /*this.selectedPredefinedNotes = this.selectedPredefinedNote.dataPredefinedNotes;
    this.selectedPredefinedNotes = this.selectedPredefinedNotes.sort((a, b) => {
      return a.NoteOrder - b.NoteOrder;
    });*/
  }

  onSave() {
    this.dialogRef.close(this.selectedPredefinedNote.NoteTemplate);
  }

  onCancel() {
    this.dialogRef.close();
  }

  onNewPredefinedNoteClick() {
    const model = new PredefinedNoteDataModel();
    model.NoteDescription = 'New Note';
    model.NoteTemplate = 'New Template';
    model.NoteSetId = this.dataNoteSet.NoteSetId;
    model.NoteOrder = this.dataNoteSet.dataPredefinedNotes[this.dataNoteSet.dataPredefinedNotes.length - 1].NoteOrder + 1;
    this.notesService.savePredefinedNoteBuilderNote(model).subscribe((data) => {
      this.selectedPredefinedNote = data;
      this.dataNoteSet.dataPredefinedNotes.push(data);
      setTimeout(() => {
        this.titleInput.nativeElement.select();
        this.titleInput.nativeElement.focus();
      }, 100);
    });
  }

  onDeletePredefinedNoteClick() {
    this.dialogService.openConfirmDialog(`Are you sure you want to delete ${this.selectedPredefinedNote.NoteDescription}?`).subscribe((result) => {
      if (result === true) {
        this.notesService.deletePredefinedNote(this.selectedPredefinedNote).subscribe(() => {
          const idx = this.dataNoteSet.dataPredefinedNotes.findIndex(p => p === this.selectedPredefinedNote);
          if (idx > -1) {
            this.dataNoteSet.dataPredefinedNotes.splice(idx, 1);
            this.selectedPredefinedNote = this.dataNoteSet.dataPredefinedNotes[0];
          }
        });
      } else {
        //
      }
    });
  }

  isEditableNote(note: PredefinedNoteDataModel) {
    return this.editableNote === note;
  }

  onEditableNoteClickOutside(note: PredefinedNoteDataModel) {
    if (note === this.editableNote) {
      this.notesService.savePredefinedNoteBuilderNote(this.editableNote).subscribe((data) => {
        this.editableNote = null;
      });
    }
  }

  onEditableNoteInputFinished(event) {
    if (this.editableNote) {
      this.notesService.savePredefinedNoteBuilderNote(this.editableNote).subscribe((data) => {
        //
      });
    }
  }

  onEditNoteClick(note: PredefinedNoteDataModel) {
    this.editableNote = note;
  }

  onNoteSetEditInputFinished(event) {
    this.notesService.savePredefinedNoteBuilderNote(this.selectedPredefinedNote).subscribe((data) => {
      // this.selectedDataNoteSet = data;
    });
  }

  isNoteSelected(note: PredefinedNoteDataModel) {
    return note === this.selectedPredefinedNote;
  }
}
